<header
    class="tw-py-4 tw-h-[78px] md:tw-w-[calc(100%-70px)] md:tw-ml-auto xl:tw-m-auto tw-w-full xl:tw-w-full tw-px-4 md:tw-px-0 tw-bg-[#0A0A75] tw-flex tw-items-center tw-text-white tw-rounded-br-[30px] lg:tw-rounded-br-[50px]"
>
    <div
        class="tw-flex tw-justify-between tw-max-w-auto tw-px-0 md:tw-px-[40px] tw-w-full"
    >
        <!-- <div
        class="tw-flex tw-justify-between tw-max-w-[1440px] tw-mx-auto tw-w-full"
    > -->
        <div class="tw-flex tw-items-center tw-gap-[12px]">
            <mat-icon
                (click)="toggleSidebar.emit()"
                class="tw-text-white !tw-block md:!tw-hidden"
                >menu</mat-icon
            >
            <img
                src="/assets/images/logo/header_desktop_white.png"
                alt="logo"
                ga-track="track"
                class="tw-cursor-pointer tw-h-auto tw-w-[120px]"
                (click)="toHomePage()"
            />
            <div class="md:tw-flex tw-items-center tw-gap-1 tw-hidden">
                <span class="!tw-mb-0 !tw-text-[16px] !tw-font-normal">
                    {{ "DASHBOARD.DASHBOARD_HEADER.WELCOME" | translate }},
                </span>
                <span
                    class="!tw-mb-0 !tw-text-[16px] !tw-font-bold !tw-capitalize"
                >
                    {{ userData?.username }}
                </span>
            </div>
        </div>
        <div class="">
            <div
                class="tw-visible tw-flex tw-flex-grow tw-justify-end tw-py-[16px] tw-items-center max tw-gap-3"
            >
                <span
                    class="tw-text-[14px] tw-flex tw-items-center tw-cursor-pointer"
                    (click)="toggleDropdown('LANGUAGE')"
                    [matMenuTriggerFor]="LANGUAGE"
                >
                    <span>{{ selectedLanguage | uppercase | translate }} </span>

                    <mat-icon
                        class="tw-text-white !tw-hidden lg:!tw-inline-block tw-ml-1"
                        >language</mat-icon
                    >
                </span>

                <mat-menu
                    class="!tw-relative !tw-py-0 !tw-top-[10px] !tw-rounded-xl !tw-z-[6999] tw-w-auto tw-h-auto"
                    #LANGUAGE="matMenu"
                >
                    <button
                        mat-menu-item
                        class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        ga-track="track"
                        (click)="switchLanguage('en', true)"
                        style="padding: 0px 16px"
                    >
                        <p class="!tw-mb-0" ga-track="track">
                            {{ "LANG.EN" | translate }}
                        </p>
                    </button>
                    <hr />
                    <button
                        mat-menu-item
                        class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        ga-track="track"
                        (click)="switchLanguage('bm', true)"
                        style="padding: 0px 16px"
                    >
                        <p class="!tw-mb-0">
                            {{ "LANG.BM" | translate }}
                        </p>
                    </button>
                </mat-menu>

                <button
                    [routerLink]="['/notifications']"
                    class="tw-flex tw-items-center tw-relative"
                >
                    <span
                        *ngIf="haveNotifications"
                        class="tw-min-w-[8px] tw-min-h-[8px] tw-rounded-full tw-bg-[#FF1212] tw-absolute tw-top-[4px] tw-right-[6px]"
                    ></span>
                    <img
                        src="assets/images/dashboard/icons/notifications_white.svg"
                        alt="notifications"
                    />
                </button>

                <div
                    *ngIf="isAuthenticated"
                    class="tw-z-[5999] tw-text-[#212121]"
                >
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="menu icon"
                        class="profile-avatar tw-flex tw-items-center"
                    >
                        <svg
                            width="34"
                            height="48"
                            viewBox="0 0 34 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.0003 16.0615C14.7795 16.0615 12.9993 17.8528 12.9993 20.0625C12.9993 22.1954 14.6655 23.9345 16.7767 24.0451C16.9222 24.0332 17.0773 24.0321 17.2279 24.0449C19.33 23.9325 20.9874 22.2002 21.0012 20.0591C20.9994 17.8534 19.2064 16.0615 17.0003 16.0615ZM10.6272 20.0625C10.6272 16.5475 13.4647 13.6895 17.0003 13.6895C20.5176 13.6895 23.3733 16.5451 23.3733 20.0625V20.0692H23.3733C23.3539 23.4982 20.6567 26.3022 17.2304 26.419C17.1609 26.4214 17.0912 26.4176 17.0223 26.4078C17.0291 26.4087 17.0304 26.4086 17.0261 26.4084C17.022 26.4081 17.0152 26.4078 17.0062 26.4078C16.9867 26.4078 16.9688 26.4091 16.9576 26.4105C16.8954 26.4183 16.8327 26.4211 16.7701 26.419C13.3498 26.3024 10.6272 23.5027 10.6272 20.0625Z"
                                fill="white"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.79968 32.5767C8.5817 33.3971 7.90089 34.3358 7.6356 35.228C10.1756 37.355 13.432 38.628 17 38.628C20.5681 38.628 23.8244 37.355 26.3644 35.228C26.099 34.3354 25.4177 33.3962 24.1987 32.5756C22.2848 31.2955 19.6825 30.6182 17.0119 30.6182C14.3424 30.6182 11.731 31.295 9.79968 32.5767ZM17.0119 28.2461C20.0416 28.2461 23.1317 29.0075 25.5191 30.605L25.5217 30.6067C27.4236 31.8865 28.6336 33.6236 28.838 35.5453C28.8779 35.9198 28.7374 36.2911 28.4596 36.5455C25.4348 39.3154 21.4199 41 17 41C12.5802 41 8.56524 39.3154 5.54043 36.5455C5.26263 36.2911 5.12218 35.9198 5.16203 35.5453C5.36647 33.6236 6.57646 31.8865 8.47835 30.6067L8.48424 30.6028L8.48426 30.6028C10.8857 29.0077 13.9818 28.2461 17.0119 28.2461Z"
                                fill="white"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17 9.37209C8.92123 9.37209 2.37209 15.9212 2.37209 24C2.37209 32.0788 8.92123 38.6279 17 38.6279C25.0788 38.6279 31.6279 32.0788 31.6279 24C31.6279 15.9212 25.0788 9.37209 17 9.37209ZM0 24C0 14.6112 7.61116 7 17 7C26.3888 7 34 14.6112 34 24C34 33.3888 26.3888 41 17 41C7.61116 41 0 33.3888 0 24Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                    <mat-menu
                        class="!tw-relative !tw-z-[6999] !tw-rounded-2xl"
                        #menu="matMenu"
                    >
                        <button
                            [attr.ga-event-id]="gtmTags?.Profile?.event"
                            [attr.ga-event-category]="
                                gtmTags?.Profile?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.Profile?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            [routerLink]="['/profile']"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "COMMON.PROFILE" | translate }}
                        </button>
                        <hr style="border: 1px solid #d8d8d8" />
                        <button
                            [attr.ga-event-id]="gtmTags?.My_Application?.event"
                            [attr.ga-event-category]="
                                gtmTags?.My_Application?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.My_Application?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            [routerLink]="['/dashboard']"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "COMMON.APPLICATION_DASHBOARD" | translate }}
                        </button>
                        <hr style="border: 1px solid #d8d8d8" />
                        <button
                            [attr.ga-event-id]="
                                gtmTags?.jc3_feedback_form?.event
                            "
                            [attr.ga-event-category]="
                                gtmTags?.jc3_feedback_form?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.jc3_feedback_form?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            [routerLink]="['/feedback-form']"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "JC3.JC3_FEEDBACK_FORM" | translate }}
                        </button>
                        <hr style="border: 1px solid #d8d8d8" />
                        <button
                            [attr.ga-event-id]="gtmTags?.Log_Out?.event"
                            [attr.ga-event-category]="
                                gtmTags?.Log_Out?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.Log_Out?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            (click)="authService.signOut()"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "COMMON.LOGOUT" | translate }}
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
</header>
